import { Suspense } from 'react';
import { ThemeProvider } from '@mui/material';

import theme from '@/theme/default.ts'
import AppRoutes from '@/AppRoutes.tsx';
import { AppProvider } from '@/context/app';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ModuleFallBack from '@/components/ModuleFallBack';
import InitialDataLoader from '@/components/InitialDataLoader';
import WsNotificationConnector from '@/components/WsNotificationConnector';
// import RegisterLastActivity from '@/components/RegisterLastActivity';
import './style.css'
import CheckNewAppVersion from './components/CheckNewAppVersion';
import { IdleProvider } from './context/IdleProvider.tsx';

function App() {

    return (<ThemeProvider theme={theme}>
        <Suspense fallback={<ModuleFallBack />}>
            <AppProvider>
                <CheckNewAppVersion />
                <InitialDataLoader />
                {/* <RegisterLastActivity /> */}
                <WsNotificationConnector />
                {/* Incluye la logica de RegisterLastActivity */}
                <IdleProvider>
                    <AppRoutes />
                </IdleProvider>
                <ToastContainer theme={'colored'} />
            </AppProvider>
        </Suspense>
    </ThemeProvider>

    )
}

export default App
